'use client';

import dynamic from 'next/dynamic';
import { LocallyDropdownInner } from '@repo/ui/src/components/LocallyDropdown';
import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';

const { locally } = publicRuntimeConfig;

const traegerConfig = {
  companyId: locally.companyId,
  companyName: locally.companyName,
  domain: locally.domain,
};

interface Props {
  className?: string;
  upc: string;
}

export { LocallyDropdownInner };

const LocallyDropdown = dynamic(
  () =>
    Promise.resolve(({ upc, className }: Props) => (
      <LocallyDropdownInner upc={upc} config={traegerConfig} className={className} />
    )),
  { ssr: false },
);

export default LocallyDropdown;
